import '../globals.css'
import './homepage.css'
import websiteData from '../../data/websiteData'
import Aurora from "../effects/Aurora";

const { hero } = websiteData

export default function HomePage() {
    return (
        <section className="hero">
            <Aurora
                colorStops={["#0D1F3C", "#2563EB", "#3B82F6"]}
                blend={0.6}
                amplitude={0.8}
                speed={0.6}
            />

            <span className="hero-eyebrow">P&C Insurance AI</span>

            <div className="hero-layout">
                <div className="hero-left">
                    <h1>{hero.title}</h1>
                    <p className="hero-paragraph">{hero.description}</p>
                    <button className="hero-cta">{hero.cta}</button>
                </div>

            </div>

        </section>
    )
}